import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions.js';
import Notify from '../shared/notify.jsx';

class TestNotify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <div>
                <h1>Notify </h1>

                <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <input type="text" ref="riferimento" className="form-control" id="message" defaultValue="Scrivi un messaggio e clicca su un bottone" />
                </div>


                <div className="btn-group" role="group" >
                    <button type="button" className="btn btn-success" onClick={() => this.props.addNotify('SUCCESS', this.refs.riferimento.value)}>Success</button>
                    <button type="button" className="btn btn-info" onClick={() => this.props.addNotify('INFO', this.refs.riferimento.value)}>Info</button>
                    <button type="button" className="btn btn-warning" onClick={() => this.props.addNotify('WARNING', this.refs.riferimento.value)}>Warning</button>
                    <button type="button" className="btn btn-danger" onClick={() => this.props.addNotify('DANGER', this.refs.riferimento.value)}>Danger</button>
                </div>

                <hr />
                <Notify />
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    console.log('[testNotify.JSX]: mapDispatchToProps');
    return {
        addNotify: function addNotify(tipo, messaggio) {
            console.log('[addNotify] tipo:' + tipo + ' messaggio: ' + messaggio);
            return dispatch(AppActions.addNotify(tipo, messaggio));
        }
    }
};

TestNotify = connect(null, mapDispatchToProps)(TestNotify);

export default TestNotify;